/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

export default function HistoryIcon({
  width = 13,
  height = 13,
}) {
  return (
    <span
      style={{
        display: 'inline-flex',
        width,
        height,
        flexShrink: 0,
      }}
      aria-hidden
    >
      <svg width="100%" height="100%" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.16667 2.72733V1.16667C1.16667 0.844501 0.905499 0.583333 0.583333 0.583333C0.261167 0.583333 0 0.844501 0 1.16667V3.5C0 4.14433 0.522335 4.66667 1.16667 4.66667H3.5C3.82217 4.66667 4.08333 4.4055 4.08333 4.08333C4.08333 3.76117 3.82217 3.5 3.5 3.5H2.05442C2.06627 3.48545 2.07758 3.47033 2.0883 3.45467C2.69558 2.56722 3.56422 1.88365 4.58028 1.50385C5.77933 1.05565 7.10091 1.06143 8.29599 1.52011C9.49107 1.97879 10.4772 2.85869 11.0684 3.99402C11.6597 5.12936 11.8154 6.44175 11.5061 7.6839C11.1968 8.92606 10.4439 10.0122 9.3893 10.7377C8.33467 11.4633 7.05112 11.778 5.78049 11.6228C4.50986 11.4675 3.33988 10.8529 2.491 9.89477C1.77166 9.08286 1.32498 8.07179 1.20474 7.00319C1.16872 6.68304 0.908099 6.42129 0.585934 6.42155C0.263767 6.42182 -0.00252676 6.68376 0.0269834 7.00457C0.151634 8.35968 0.704781 9.64579 1.61388 10.6719C2.65244 11.8441 4.08382 12.596 5.63835 12.786C7.19288 12.9759 8.76321 12.5908 10.0535 11.7032C11.3437 10.8156 12.2648 9.48673 12.6432 7.96704C13.0216 6.44735 12.8312 4.84174 12.1078 3.45273C11.3844 2.06373 10.178 0.98723 8.71588 0.426071C7.25378 -0.135089 5.63693 -0.142164 4.16998 0.406178C2.95203 0.861443 1.90722 1.67347 1.16667 2.72733Z" fill="#3C5873" />
        <path d="M6.41667 2.33333C6.0945 2.33333 5.83333 2.5945 5.83333 2.91667V6.68889C5.83333 6.68889 5.83333 6.84098 5.90726 6.9554C5.9567 7.05241 6.03383 7.1367 6.13515 7.1952L8.83002 8.75108C9.10902 8.91217 9.46578 8.81657 9.62687 8.53757C9.78795 8.25857 9.69236 7.9018 9.41335 7.74072L7 6.34737V2.91667C7 2.5945 6.73883 2.33333 6.41667 2.33333Z" fill="#3C5873" />
      </svg>
    </span>
  );
}

HistoryIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};
